export const CONFIRMATION_DIALOG__DELETE_SITE_ALIAS = 'CONFIRMATION_DIALOG__DELETE_SITE_ALIAS';
